module.exports = __webpack_public_path__ + "img/zhiyeminicode.dcc89daa.png";